import { useEffect } from 'preact/hooks'

interface DarkModeHookProps {
  isDarkMode: boolean
}

export const useDarkMode = ({ isDarkMode }: DarkModeHookProps) => {
  useEffect(() => {
    const htmlElement = document.documentElement

    isDarkMode ? htmlElement.setAttribute('data-theme', 'dark') : htmlElement.removeAttribute('data-theme')
  }, [isDarkMode])
}
